import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Component, OnInit, ViewChild } from '@angular/core'
import { FormBuilder, FormControl, FormGroup } from '@angular/forms'
import { MatSelect } from '@angular/material/select'
import { NgxSpinnerService } from 'ngx-spinner'
import { AuthenticationService } from 'src/app/_services'
import { environment } from 'src/environments/environment'
import Swal from 'sweetalert2'

@Component({
  selector: 'app-edit-inventory',
  templateUrl: './edit-inventory.component.html',
  styleUrls: ['./edit-inventory.component.css']
})
export class EditInventoryComponent implements OnInit {
  viewEditar = false
  PlaceOrderCustomer = []
  FormReceivingProducts: FormGroup
  PlaceProducts = []
  PlaceProducts2 = []
  editInventory: any
  viewEditar2 = false
   Toast = Swal.mixin({
      toast: true,
      position: 'center',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: false,
      background: ' #ffffff29',
  
      padding: '80px 20px 80px',
  
      didOpen: toast => {
        Swal.showLoading()
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })
  @ViewChild('ProdustSelect') ProdustSelect: MatSelect
  indexTabs = new FormControl(0)
  constructor (
        private spinner: NgxSpinnerService,
    private _httpClient: HttpClient,
    private authenticationService: AuthenticationService,
    private formbuider: FormBuilder
  ) {
    this.PlaceOrderCustomer = []
  }

  ngOnInit (): void {
    this.FormReceivingProducts = this.formbuider.group({
      customer: [''],
      PlaceProducts: [''],
      quantity: [0],
    })
    this.OnSelectCostumer()
  }
  OnSelectCostumer () {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}
    Request['companyId'] = json.companyIdWh
    Request['active'] = '1'
    this._httpClient
      .post<any>(`${environment.apiUrl}/Shipping/PlaceOrderCustomer`, Request, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + json.token
        })
      })
      .subscribe((response: any) => {
        this.PlaceOrderCustomer = response
      })
  }

  OnSelectProducts () {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}

    Request['customerId'] = Number(
      this.FormReceivingProducts.controls.customer.value
    ) //datos.selCostumer;

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Shipping/PlaceOrderViewProductsOrderItems`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        this.PlaceProducts = response
        this.PlaceProducts2 = response
        this.viewEditar = true
      })
  }
  onKeyPlaceProducts (value) {
    console.log(value)
    if (value == '') {
      this.PlaceProducts2 = this.PlaceProducts
    } else {
      this.PlaceProducts2 = this.searchP(value)
    }
    //this.fmorderitems.controls.PlaceProducts.
    this.ProdustSelect.open()
  }
  searchP (value: string) {
    let filter = value.toLowerCase()

    return this.PlaceProducts.filter(object => {
      if (object['ItemNumber'].toLowerCase().includes(filter)) {
        return object
      }
    })
  }
  onClickEditInventory(){
    var js=this.FormReceivingProducts.controls.PlaceProducts.value
    this.FormReceivingProducts.controls.quantity.setValue(js.available)
console.log(this.FormReceivingProducts.controls.PlaceProducts.value,"edit")
this.editInventory=js
this.viewEditar2=true
  }
  onEditInventoryModule_Update () {
    var js={
      "tblReceivingProductsItemsId": Number(this.editInventory.receivingID),
      "tblReceivingProductsLocationId": Number(this.editInventory.locationID),
      "quantity": Number(this.FormReceivingProducts.controls.quantity.value),
    };
        
        
    this.spinner.show()
  
    
        this._httpClient
          .put<any>(
            `${
              environment.apiUrl
            }/Administracion/EditInventoryModule_Update`,js,
    
            {
              headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Access-Control-Allow-Methods': '*',
                Authorization:
                  'Bearer ' + this.authenticationService.currentUserValue.token
              })
            }
          )
          .subscribe((response: any) => {
            this.spinner.hide()
              console.log(response,"EditInventoryModule_Update")
              if(response=="success"){

                this.Toast.fire({
                  icon: 'success',
                  title: 'It was updated successfully'
                })

              }
          })
      }
}
